<template>
  <div>
    <h4>{{ $t('contentTypeConfiguration.csvColumns') }}</h4>

    <input
      id="file"
      ref="file"
      type="file"
      accept=".csv"
      style="display: none"
      @change="uploadFile"
    />

    <vf-button
      id="file-upload-button"
      :size="buttonSizes.large"
      :variant="buttonVariants.secondary"
      @click="triggerFileUpload"
    >
      {{ $t('contentTypeConfiguration.uploadCsv') }}
    </vf-button>

    <div v-if="headers" id="identified-headers-list">
      <p>{{ $t('contentTypeConfiguration.identifiedColumns') }}</p>
      <ul>
        <li v-for="header in headers" :key="header">
          {{ header }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script src="./CsvReader.script.ts"></script>
<style lang="scss" src="./CsvReader.styles.scss" scoped></style>
